<div class='agpr-quickEditRefinementsSearch'>
    <div class="agpr-quickEditRefinementsSearch-header">
        <h2 class="agpr-quickEditRefinementsSearch-title">{{ 'Discover.targeting.panels.searchRefinements' | localize }}</h2>
        <agpr-dropdown
            [id]="'agpr_quickEditRefinementsSearch_dropdown'"
            [options]="refinementSearchParams"
            (change)="handleRefinementChange($event);"
            [disabled]="!refinementSearchParams?.length"
            [showInput]="false"
            [replaceInputIcon]="'fa-regular fa-duotone fa-square-plus'"
        ></agpr-dropdown>
    </div>

    <ng-container
        [formGroup]="searchForm"
    >
        <ng-container
            formGroupName="general"
        >
            <div class="agpr-quickEditRefinementsSearch-searchForm">
                <!-- mediaTypes -->
                @if(_searchParamsVisible?.mediaTypes) {
                    <div class="agpr-quickEditRefinementsSearch-searchForm-section">
                        <agpr-delete-container
                            [key]="'mediaTypes'"
                            (removeParam)="removeParam($event)"
                        >
                            <agpr-include-exclude-chips
                                formControlName="mediaTypes"
                                id="quickEditRefinementsSearch.mediaTypes"
                                headerLabel="Discover.targeting.searchFieldLabels.mediaTypes"
                                [placeholder]="'Discover.targeting.searchFieldLabels.select.placeholder'"
                                [optionsFetcher]="journodexEnumsService.getMediaTypes()"
                                keyLookupField="enumValue"
                                labelLookupField="displayString"
                                [showIncludeAll]="true"
                                [tooltipPath]="'Discover.targeting.definition.media.'"
                                itemTooltipPosition="left"
                                headingLevel="5"
                            ></agpr-include-exclude-chips>
                        </agpr-delete-container>
                    </div>
                }

                <!-- productTypes -->
                @if(_searchParamsVisible?.productTypes) {
                    <div class="agpr-quickEditRefinementsSearch-searchForm-section">
                        <agpr-delete-container
                            [key]="'productTypes'"
                            (removeParam)="removeParam($event)"
                        >
                            <agpr-include-exclude-chips
                                formControlName="productTypes"
                                id="quickEditRefinementsSearch.productTypes"
                                headerLabel="Discover.targeting.searchFieldLabels.productTypes"
                                [placeholder]="'Discover.targeting.searchFieldLabels.select.placeholder'"
                                [optionsFetcher]="journodexEnumsService.getProductTypes()"
                                keyLookupField="enumValue"
                                labelLookupField="displayString"
                                [showIncludeAll]="false"
                                [tooltipPath]="'Discover.targeting.definition.product.'"
                                itemTooltipPosition="left"
                                headingLevel="5"
                            ></agpr-include-exclude-chips>
                        </agpr-delete-container>
                        <agpr-message
                            *ngIf="incompatibleProductTypes.length > 0"
                            [severity]="messageSeverityEnum.warning"
                            class="agpr-quickEditRefinementsSearch-incompatibleProductTypeWarning"
                        >
                            <p>{{ 'Discover.targeting.searchFieldLabels.productTypes.incompatibilityWarning.line1' | localize }}</p>
                            <ul
                                *ngFor="let incompatibleProductType of incompatibleProductTypes"
                                class="agpr-quickEditRefinementsSearch-incompatibleProductTypeWarning-list"
                            >
                                <li>{{ incompatibleProductType }}</li>
                            </ul>
                            <p>{{ 'Discover.targeting.searchFieldLabels.productTypes.incompatibilityWarning.line2' | localize }} <a
                                href="http://help.agilitypr.com/en/articles/5409399-understanding-media-product-types" target="_blank"
                                class="agpr-quickEditRefinementsSearch-incompatibleProductTypeWarning-link">
                                {{ 'Discover.targeting.actions.learnMore' | localize }}</a>.</p>
                        </agpr-message>
                    </div>
                }

                <!-- marketSectors -->
                @if(_searchParamsVisible?.marketSectors) {
                    <div class="agpr-quickEditRefinementsSearch-searchForm-section">
                        <agpr-delete-container
                            [key]="'marketSectors'"
                            (removeParam)="removeParam($event)"
                        >
                            <agpr-include-exclude-chips
                                formControlName="marketSectors"
                                id="quickEditRefinementsSearch.marketSectors"
                                headerLabel="Discover.targeting.searchFieldLabels.marketSectors"
                                [placeholder]="'Discover.targeting.searchFieldLabels.select.placeholder'"
                                [optionsFetcher]="journodexEnumsService.getMarketSectors()"
                                keyLookupField="enumValue"
                                labelLookupField="displayString"
                                [showIncludeAll]="false"
                                [tooltipPath]="'Discover.targeting.definition.marketSectors.'"
                                itemTooltipPosition="left"
                                headingLevel="5"
                            ></agpr-include-exclude-chips>
                        </agpr-delete-container>
                    </div>
                }

                <!-- coverageFocuses -->
                @if(_searchParamsVisible?.coverageFocuses) {
                    <div class="agpr-quickEditRefinementsSearch-searchForm-section">
                        <agpr-delete-container
                            [key]="'coverageFocuses'"
                            (removeParam)="removeParam($event)"
                        >
                            <agpr-include-exclude-chips
                                formControlName="coverageFocuses"
                                id="quickEditRefinementsSearch.coverageFocuses"
                                headerLabel="Discover.targeting.searchFieldLabels.coverageFocuses"
                                [placeholder]="'Discover.targeting.searchFieldLabels.select.placeholder'"
                                [optionsFetcher]="journodexEnumsService.getCoverageFocuses()"
                                keyLookupField="enumValue"
                                labelLookupField="displayString"
                                [showIncludeAll]="false"
                                [tooltipPath]="'Discover.targeting.definition.coverageFocus.'"
                                itemTooltipPosition="left"
                                headingLevel="5"
                            ></agpr-include-exclude-chips>
                        </agpr-delete-container>
                    </div>
                }

                <!-- productFrequencies -->
                @if(_searchParamsVisible?.productFrequencies) {
                    <div class="agpr-quickEditRefinementsSearch-searchForm-section">
                        <agpr-delete-container
                            [key]="'productFrequencies'"
                            (removeParam)="removeParam($event)"
                        >
                            <agpr-include-exclude-chips
                                formControlName="productFrequencies"
                                id="quickEditRefinementsSearch.productFrequencies"
                                headerLabel="Discover.targeting.searchFieldLabels.productFrequencies"
                                [placeholder]="'Discover.targeting.searchFieldLabels.select.placeholder'"
                                [optionsFetcher]="journodexEnumsService.getProductFrequencies()"
                                keyLookupField="enumValue"
                                labelLookupField="displayString"
                                [showIncludeAll]="false"
                                [tooltipPath]="'Discover.targeting.definition.publicationFrequencies.'"
                                itemTooltipPosition="left"
                                headingLevel="5"
                            ></agpr-include-exclude-chips>
                        </agpr-delete-container>
                    </div>
                }

                <!-- targetAudiences -->
                @if(_searchParamsVisible?.targetAudiences) {
                    <div class="agpr-quickEditRefinementsSearch-searchForm-section">
                        <agpr-delete-container
                            [key]="'targetAudiences'"
                            (removeParam)="removeParam($event)"
                        >
                            <agpr-include-exclude-chips
                                formControlName="targetAudiences"
                                id="quickEditRefinementsSearch.targetAudiences"
                                headerLabel="Discover.targeting.searchFieldLabels.targetAudiences"
                                [placeholder]="'Discover.targeting.searchFieldLabels.select.placeholder'"
                                [optionsFetcher]="journodexEnumsService.getTargetAudiences()"
                                keyLookupField="enumValue"
                                labelLookupField="displayString"
                                [showIncludeAll]="true"
                                [tooltipPath]="'Discover.targeting.definition.targetAudiences.'"
                                itemTooltipPosition="left"
                                headingLevel="5"
                            ></agpr-include-exclude-chips>
                        </agpr-delete-container>
                    </div>
                }

                @if(isEmpty) {
                    <div class="agpr-quickEditRefinementsSearch-searchForm-empty">
                        <agpr-message
                            [severity]="messageSeverities.noContent"
                            [style]="agprComponentStyle.social"
                        >
                            {{ 'Discover.recommendedRecipients.quickEdit.empty' | localize:{ 'section': 'Discover.targeting.panels.searchRefinements' } }}
                        </agpr-message>
                    </div>
                }
            </div>
        </ng-container>

    </ng-container>
</div>
